import Answers from "./../../Components/Answers";
export default function COR() {
  return (
    <>
      <Answers />
    </>
  );
}
